import type { PortfolioSnapshotResponse } from "../../lib/api";
import { formatAddress } from "../../lib/format";

export function UnquotedBlock({
	entries,
}: {
	entries: PortfolioSnapshotResponse["unquotedEntries"];
}) {
	return (
		<aside className="rounded-lg border border-amber-900/40 bg-amber-950/30 p-3">
			<p className="text-xs font-semibold uppercase tracking-wide text-amber-300">
				{entries.length} unpriced {entries.length === 1 ? "entry" : "entries"}
			</p>
			<p className="mt-1 text-[11px] text-amber-200/70">
				Ledger rows we couldn't price (vault not in instruments, no quote). Not
				counted in total or weights.
			</p>
			<ul className="mt-2 space-y-1 text-[11px] font-mono text-amber-100/80">
				{entries.map((e, i) => (
					<li key={`${e.vaultAddress ?? "no-vault"}:${i}`}>
						{e.protocol} · {formatAddress(e.vaultAddress)} ·{" "}
						<span className="text-amber-300">{e.reason}</span>
					</li>
				))}
			</ul>
		</aside>
	);
}
